export default __webpack_public_path__ + "static/banner-finance-how-much-should-you-spend-when-renovating-da22da2053d95714493e61e449643e1b.webp";